import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject, BehaviorSubject } from 'rxjs';
import { TicketMessage } from '../Models/help&support';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatServiceService {
      baseurl=`${environment.baseUrl}`
  private hubConnection: signalR.HubConnection;
  private readonly baseUrl = 'https://safroo-dev-api.azurewebsites.net'; 

  private messageReceivedSource = new Subject<TicketMessage>();
  messageReceived$ = this.messageReceivedSource.asObservable();

  private isConnected$ = new BehaviorSubject<boolean>(false);

  constructor() {
  this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(`${this.baseUrl}/tickethub`, {
  withCredentials: true
})
    .withAutomaticReconnect()
    .build();

  this.registerOnServerEvents();
  this.startConnection();
}

  private async startConnection() {
    try {
      await this.hubConnection.start();

      this.isConnected$.next(true);
    } catch (err) {
      console.error('SignalR Connection Error: ', err);
      this.isConnected$.next(false);
      setTimeout(() => this.startConnection(), 3000);
    }

    this.hubConnection.onreconnected(() => {

      this.isConnected$.next(true);
    });

    this.hubConnection.onclose(() => {

      this.isConnected$.next(false);
    });

    this.hubConnection.onreconnecting(() => {

    });
  }

  private registerOnServerEvents() {
   this.hubConnection.on('ReceiveTicketMessage', (
  messageId,
  ticketActivityId,
  senderUserId,
  reciversUserId,
  messageText,
  sentAt,
  isSeen,
  seenAt,
  isDeleted,
  roleId
) => {
  const msg: TicketMessage = {
    messageId,
    ticketActivityId,
    senderUserId,
    reciversUserId,
    messageText,
    sentAt,
    isSeen,
    seenAt,
    isDeleted,
    roleId
  };

  this.messageReceivedSource.next(msg);
});

  }

  async JoinTicketChat(userId: number) {
    await this.ensureConnection();
    return this.hubConnection.invoke('JoinTicketChat', userId)
      .catch(err => console.error('JoinChat Error: ', err));
  }

                         
  async SendTicketMessage(senderId: number, ticketId: number, message: string, reciversId: number ) {
     
    await this.ensureConnection();
    return this.hubConnection.invoke('SendTicketMessage', senderId, ticketId, message,reciversId)
      .catch(err => console.error('SendMessage Error: ', err));
  }

  private async ensureConnection(): Promise<void> {
    if (this.hubConnection.state !== signalR.HubConnectionState.Connected) {

      await new Promise<void>((resolve) => {
        const sub = this.isConnected$.subscribe(connected => {
          if (connected) {
            resolve();
            sub.unsubscribe();
          }
        });
      });
    }
  }
}
